import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import {useDeleteCurrencyMutation} from 'api';
import {useSnackbar} from 'notistack';

function CurrencyDeleteIconButton({CurrencyId}) {
  const [deleteCurrency, deleteCurrencyResult] = useDeleteCurrencyMutation();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const {enqueueSnackbar} = useSnackbar();

  const handleDelete = async () => {
    try {
      await deleteCurrency(CurrencyId).unwrap();
      enqueueSnackbar('Currency deleted', {variant: 'success'});
      setIsModalOpen(false);
    } catch (error) {
      const message = error.status === 400 ? error.data?.details?.[0]?.message : undefined;
      enqueueSnackbar(message || `Error deleting Currency`, {variant: 'error'});
    }
  };

  return (
    <>
      <Dialog open={isModalOpen} maxWidth="xs">
        <DialogTitle>Delete Currency</DialogTitle>
        <DialogContent dividers>Are you sure you want to delete this Currency?</DialogContent>
        <DialogActions>
          <Button
            disabled={deleteCurrencyResult.isLoading}
            autoFocus
            onClick={() => setIsModalOpen(false)}
          >
            Cancel
          </Button>
          <Button
            disabled={deleteCurrencyResult.isLoading}
            color="error"
            endIcon={deleteCurrencyResult.isLoading ? <CircularProgress size={16} /> : null}
            onClick={handleDelete}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <IconButton
        onClick={() => setIsModalOpen(true)}
        disabled={deleteCurrencyResult.isLoading}
        aria-label="delete"
        color="error"
      >
        <DeleteIcon />
      </IconButton>
    </>
  );
}

export default CurrencyDeleteIconButton;
